module.exports = __webpack_public_path__ + "static/media/person_darkbleu.edb17c2d.svg";